import styled from "@emotion/styled";

const PageWrapper = styled.div`
    background-color: ${ (props) => props.theme.pageColor};
`
const SectionWrapper = styled.div`
    margin: ${props=> props.m ? props.m : '1.5px 0'};
    padding: ${props=> props.p ? props.p : '0px'};
`
const P = styled.p`
    color: ${ (props) => props.theme.textPrimary};
    font-size: ${props=> props.fs ? props.fs : '16px'};
    margin: ${props=> props.m ? props.m : '0px'};
    text-align: ${props=> props.align ? props.align : 'left'};
    max-width: ${props=> props.maxWidth ? props.maxWidth : '100%'};
`
const Heading = styled.h2`

  font-family: "Poppins-Bold";
    color: ${ (props) => props.theme.textPrimary};
    font-size: ${props=> props.fs ? props.fs : '25px'};
    margin: ${props=> props.m ? props.m : '0px'};
    text-align: ${props=> props.align ? props.align : 'left'};
    max-width: ${props=> props.maxWidth ? props.maxWidth : '100%'};
    @media screen and (max-width:599px){
        font-size: 30px;
    }
`
const Btn = styled.a`
    color: ${ (props) => props.theme.textPrimary};
    background-color: ${ (props) => props.theme.btnPrimary};
    border: 1px solid ${ (props) => props.theme.btnPrimary};
    border-radius: 8px;
    font-size: 15px;
    box-shadow: 0px 0px 50px -15px ${ (props) => props.theme.btnPrimary};
    text-decoration: none;
    display: inline-block;
    margin: ${props=> props.m ? props.m : '0px'};
    padding: ${props=> props.p ? props.p : '5px 15px'};

    &:hover{
        background-color: transparent;
        transition: all .3s;
    }
`

export { PageWrapper, SectionWrapper, P, Heading, Btn }